import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { memo } from 'react';
import { Asset } from '../../types/asset';
import { SecondaryDeviceDetail } from '../../types/device';
import MultipleDeviceCardBody from './MultipleDeviceCardBody';
import MultipleDeviceCardFooter from './MultipleDeviceCardFooter';
import MultipleDeviceCardHeader from './MultipleDeviceCardHeader';

type Props = {
  device: SecondaryDeviceDetail;
  asset: Asset;
};

function MultipleDeviceCard({ device, asset }: Props) {
  return (
    <Card
      overrides={{
        Root: {
          style: {
            flexShrink: 0,
            boxSizing: 'border-box',
            borderLeftWidth: '1px',
            borderRightWidth: '1px',
            borderTopWidth: '1px',
            borderBottomWidth: '1px',
          },
        },
        Contents: {
          style: {
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
          },
        },
        Body: {
          style: {
            marginBottom: 0,
          },
        },
      }}
    >
      <MultipleDeviceCardHeader device={device} />
      <StyledDivider
        $size="cell"
        style={{ marginTop: 0, marginBottom: 0 }}
      />
      <MultipleDeviceCardBody device={device} />
      <StyledDivider
        $size="cell"
        style={{ marginTop: 0, marginBottom: 0 }}
      />
      <MultipleDeviceCardFooter
        device={device}
        asset={asset}
      />
    </Card>
  );
}

export default memo(MultipleDeviceCard);
